var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1482 20.2965C15.9915 20.2965 18.2965 17.9915 18.2965 15.1482C18.2965 12.3049 15.9915 10 13.1482 10C10.3049 10 8 12.3049 8 15.1482C8 17.9915 10.3049 20.2965 13.1482 20.2965Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6049 47.7548C18.8619 47.7548 10.6676 41.4203 8.07416 32.7755C8.00163 32.5183 7.99019 32.2476 8.04076 31.9852C8.09133 31.7227 8.20251 31.4757 8.36544 31.2638C8.52837 31.0519 8.73854 30.881 8.97921 30.7647C9.21987 30.6484 9.48437 30.5899 9.75163 30.5939H47.439C47.7062 30.5899 47.9707 30.6484 48.2114 30.7647C48.4521 30.881 48.6622 31.0519 48.8252 31.2638C48.9881 31.4757 49.0993 31.7227 49.1498 31.9852C49.2004 32.2476 49.189 32.5183 49.1164 32.7755C46.5445 41.4203 38.348 47.7548 28.6049 47.7548Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0369 20.2965C46.8802 20.2965 49.1852 17.9915 49.1852 15.1482C49.1852 12.3049 46.8802 10 44.0369 10C41.1936 10 38.8887 12.3049 38.8887 15.1482C38.8887 17.9915 41.1936 20.2965 44.0369 20.2965Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.749ce5972edd25fd834065bcad836a1a.svg";
export { ForwardRef as ReactComponent };